export function esEmpleadoReciboHonorarios(ficha) {
  const tipo = String(ficha?.tipo_contratacion || "")
    .trim()
    .toLowerCase();
  if (!tipo) {
    return false;
  }
  return tipo.includes("honorario") || tipo === "rh" || tipo === "recibo_honorarios";
}

export function esEmpleadoPlanillaInterna(ficha) {
  if (!ficha) {
    return false;
  }
  if (String(ficha.tipo_planilla || "").toLowerCase() === "solo_interna") {
    return true;
  }
  return (
    String(ficha.tipo_contratacion || "")
      .trim()
      .toLowerCase() === "interno"
  );
}

export function modalidadFichaSsoma(ficha) {
  if (esEmpleadoReciboHonorarios(ficha)) {
    return "rh";
  }
  if (esEmpleadoPlanillaInterna(ficha)) {
    return "interno";
  }
  if (String(ficha?.tipo_planilla || "").toLowerCase() === "dual") {
    return "dual";
  }
  return "planilla";
}

export function etiquetaModalidadFichaSsoma(modalidad) {
  if (modalidad === "rh") {
    return "RH (Recibo por Honorarios)";
  }
  if (modalidad === "interno") {
    return "Solo interna";
  }
  if (modalidad === "dual") {
    return "Dual (PLAME + interna)";
  }
  return "Planilla";
}

export function fichaCoincideModalidad(ficha, filtro) {
  if (!filtro) {
    return true;
  }
  return modalidadFichaSsoma(ficha) === filtro;
}

export function mostrarEtiquetaModalidadSsoma(ficha, planillaInternaActiva) {
  const modalidad = modalidadFichaSsoma(ficha);
  return modalidad === "rh" || Boolean(planillaInternaActiva);
}
